import { ColDef, ColGroupDef } from "ag-grid-community";
import { PriceGroupsStoreView } from "models/dbModels/priceGroups/PriceGroupsStore";
import { useState } from "react";
import { Form } from "react-bootstrap";
import { Spinner } from "components";
import { useAppDispatch } from "redux/hooks";
import { bulkUpdatePriceGroupsStore, updateAssignPriceGroupTableField } from "redux/slices/AssignPriceGroup";
import { displayTooltipsIcons } from "helpers/data/dataHandling";
import { Link } from "react-router-dom";
 
export function getPriceGroupDepartmentConfig(assignPriceGroup: any, user: any, priceGroups: any): (ColDef<PriceGroupsStoreView> | ColGroupDef<PriceGroupsStoreView>)[] | null {        
    return [
        {
            headerCheckboxSelection: true,
            checkboxSelection: true,
            width: 45,
            sortable: false,
            filter: false,
            suppressHeaderMenuButton: true,
        },
        {
            field: "departmentId",
            hide: true
        },
        {
            headerName: "Name",
            field: "departmentName",
            suppressHeaderMenuButton: true,
            flex: 1,
            minWidth: 140,
            initialSort: "asc",
            cellClass: "aggrid-header-link-lext",
            cellRendererSelector: (params) => {
                return {
                    component: 'baseCellRenderer',
                    params: {
                                children: <Link to={''} >{params.data?.departmentName}</Link>,
                            }
                }
            },
        },
        {
            headerName: "Current Price Group",
            flex: 1,
            minWidth: 180,
            suppressHeaderMenuButton: true,
            cellRendererSelector: (params) => {
                return {
                    component: 'baseCellRenderer',
                    params: {
                        children: <span>{params.data?.priceGroupName}{displayTooltipsIcons(params.data?.priceGroupName!)}</span>
                    }
                }
            }
        },
        {
            headerName: "New Price Group",
            flex: 3,
            field: "newPriceGroupId",
            minWidth: 200,
            suppressHeaderMenuButton: true,
            cellRendererSelector: (params) => {
                return {
                    component: 'baseCellRenderer',
                    params: {
                                children: <PriceGroupDropdown assignPriceGroup={assignPriceGroup} props={params.data as PriceGroupsStoreView} user={user} priceGroups={priceGroups}/>,
                            }                   
                }
            }
        }
    ];
}

type priceGroupDropdownProps = {props: any, assignPriceGroup: any, user: any, priceGroups: any}
const PriceGroupDropdown = ({props, assignPriceGroup, user, priceGroups}: priceGroupDropdownProps) => {
        const dispatch = useAppDispatch(); 
        const tooltipType: string = props.id === -1 ? "Base Sell Price" : props.id === -2 ? "Mixed" : props.id;
        const [departmentValue, setDepartmentValue] = useState(props.newPriceGroupId ? props.newPriceGroupId : "Mixed");
        const [loadingValue, setLoadingValue] = useState(false);
        async function handleDepartmentUpdate(newPriceGroupId: number) {
            setLoadingValue(true);
            await dispatch(bulkUpdatePriceGroupsStore({
                managedStockFilter: {
                    departmentIds: [props.departmentId],
                },
                newPriceGroupId: newPriceGroupId,
                storeIds: [assignPriceGroup.currentStore]
            })).then((res) => {
                if (res.data) {
                    setDepartmentValue(newPriceGroupId);
                    const index = assignPriceGroup.departments.findIndex((department: any) => department.departmentId === props.departmentId);
                    dispatch(updateAssignPriceGroupTableField({ field: "departments", index: index, key: "newPriceGroupId", value: newPriceGroupId }));
                }
            }).catch((error: any) => {

            });
            setLoadingValue(false);
    }
    return (
            <div style={{ maxWidth: "250px", display: "flex" }}>
                {loadingValue ?
                    <span><Spinner className="spinner-border-sm me-1" tag="span" color="primary" />Saving... </span>
                    :
                    <>
                        <Form.Group style={{ margin: "-3px 0px" }}>
                            <Form.Select
                                disabled={!user.permissions.assignPriceGroups.canUpdate}
                                className="custom-select"
                                value={departmentValue}
                                onChange={(e) => handleDepartmentUpdate(parseInt(e.target.value))}>
                                <option value={0}></option>
                                <option value={-1}>Base Sell Price</option>
                                <option value={-2} hidden>Mixed</option>
                                {priceGroups.table.map((priceLevel: any, index: any) => {
                                    return <option key={index} value={priceLevel.id}>{priceLevel.name}</option>
                                })}
                            </Form.Select>
                        </Form.Group>
                        {displayTooltipsIcons(tooltipType)}
                    </>
                }
            </div>
    );
};
